import React, {Component} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Table, Icon, Button } from 'antd';

import Page from '../../shared/components/Page';

import { serverLoadAccounts } from '../actions';

class UserAccounts extends Component{
    constructor(props){
        super(props);

        this.state = {
        }

        const EditAccountColumn = () => (
            <div>
                <a href="" onClick={(e) => {
                    e.preventDefault();
                }}><Icon type="edit" style={{ marginRight: 10 }}/></a>
                <a href="" onClick={(e) => {
                    e.preventDefault();
                }}><Icon type="delete" /></a>
            </div>
        );

        this.columns = [{
                title: 'Username',
                dataIndex: 'username',
                key: 'username'
            },{
                title: 'First Name',
                dataIndex: 'firstName',
                key: 'firstName'
            },{
                title: 'Last Name',
                dataIndex: 'lastName',
                key: 'lastName',
            },{
                title: 'Admin',
                dataIndex: 'admin',
                key: 'admin',
                filters: [
                    { text: 'Yes', value: 'Yes' },
                    { text: 'No', value: 'No' },
                ],
                onFilter: (value, record) => record.admin === value,
            },
            {
                title: '',
                key: 'edit',
                render: EditAccountColumn,
            }
        ];
    }
    componentDidMount(){
        this.props.loadAccounts();
    }

    priorityEditOk(){
        //this.props.patchJobPriority(this.state.currentJob.jobId, this.state.updatedPriority);
        this.setState({
            editPriority: false,
        });
    }
    priorityEditCancel(){
        this.setState({
            editPriority: false,
        });
    }

    onSearchTermUpdate(value){
        this.setState({
            searchTerm: value,
        });
    }
    
    render(){
        const { props } = this;

        const accountsList = props.accounts.map((account, i) => {
            return {
                key: i,
                _id: account._id,
                firstName: account.user ? account.user.firstName: '',
                lastName: account.user ? account.user.lastName: '',
                username: account.username,
                admin: account.admin ? 'Yes': 'No',
            }
        });

        return(
            <Page>
                <Page.MainArea>
                    <div className="container-with-padding">
                        <h4 className="heading-level-1" style={{
                            marginBottom: 16,
                        }}>User Accounts</h4>
                        <div style={{ marginBottom: 15 }}>
                            <Link to="/admin/accounts/create">
                                <Button icon="plus" type="outlined">Create Accounts</Button>
                            </Link>
                        </div>
                        <Table
                            columns={this.columns}
                            dataSource={accountsList}
                            pagination={{ pageSize: 15 }} />
                    </div>
                </Page.MainArea>
            </Page>
        )
    }
}

UserAccounts.propTypes = {
    loadAccounts: PropTypes.func,
    jobsList: PropTypes.array,
    accounts: PropTypes.array,
}

// Map props to the store

const mapStateToProps = (state) => ({
    jobsList: state.routes.admin.get('jobsList'),
    accounts: state.routes.admin.get('accounts'),
});
  
const mapDispatchToProps = (dispatch) => ({
    loadAccounts: () => {
        dispatch(serverLoadAccounts());
    },
});
  
const UserAccountsContainer = connect(mapStateToProps,mapDispatchToProps)(UserAccounts);

export default UserAccountsContainer;


// WEBPACK FOOTER //
// ./src/admin/pages/UserAccounts.js